// <template>
// 	<div>
// 		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
// 			destroy-on-close>
// 			<template #default>
// 				<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
// 			</template>
// 			<template #footer>
// 				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
// 			</template>
// 		</vxe-modal>
// 		<statistics :data="orderdata" ref="statistics" />
// 		<edit-index :row="currentrow" ref="editIndex" @success="submit" />
// 	</div>
// </template>
// <style scoped>

// </style>

export default {
	props: {

	},
	data() {
		return {
			modal_model: false,
			modal_loading: false,
			modal_title: '弹窗',
			modal_width: 800,
			modal_height: 600,
		}
	},
	created() {

	},
	methods: {
		modal_init() {

		},
		modal_cancel() {
			this.modal_model = false
		},
		modal_onhide() {
			this.$emit('modalhide')
		},
		modal_onshow() {
			this.modal_init()
		},
		modal_show() {
			this.modal_model = true
		},
	},
}